export const TitleColor = '#bcdcff'
